import React, { useState, useEffect } from 'react'
import { COLORS_FINDER } from '@auteco/utils/chartsUtils'
import filterArray from '@auteco/utils/filterArray'
import pagination from '@auteco/utils/pagination'
import { Pagination } from '@material-ui/lab'
import FilterCategory from '../filters/FilterCategory'
import TimeLine from '../timeline/TimeLine'


const TimeLineFilters = (props) => {
  const [filterValue, setFilterValue] = useState('')
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(30);
  const { users } = props
  const isArray = (data) => {
    const newArray = []
    const json = data.pop()
    Object.entries(json).forEach((value) => {
      if (
        Array.isArray(value[1]) &&
        value[1].length > 0 &&
        value[0] !== 'datos'
      ) {
        const result = value[1].map((item, index) => ({
          ...item,
          id: `item${index}`,
          status: false,
          tableName: value[0],
          color: COLORS_FINDER[(index + 1) % 24],
          date:
            item.FechaOrden ||
            item.Fecha ||
            item.FechaCreacion ||
            item.FECHA ||
            item.FECHA_MATRICULA ||
            item.updatedIn ||
            item.lastChange ||
            item.createdIn ||
            null,
        }))
        newArray.push(result)
      }
    })
    const concatItems = newArray.reduce((a, b) => a.concat(b))
    const sorted = concatItems.sort((a, b) => (a.date > b.date ? 1 : -1))
    return sorted
  }

  const isObject = (data) => {
    const newArray = []
    Object.entries(data).forEach((value, index) => {
      if (
        Array.isArray(value[1]) &&
        value[1].length > 0 &&
        value[0] !== 'datos'
      ) {
        const result = value[1].map((item,indexed) => ({
          ...item,
          id: `item${indexed}`,
          statusHeight: false,
          tableName: value[0],
          color: COLORS_FINDER[(index + 1) % 24],
          date:
            item.FechaOrden ||
            item.Fecha ||
            item.FechaCreacion ||
            item.FECHA ||
            item.FECHA_MATRICULA ||
            item.updatedIn ||
            item.lastChange ||
            item.createdIn ||
            null,
        }))
        newArray.push(result)
      }
    })
    const concatItems = newArray.reduce((a, b) => a.concat(b))
    const sorted = concatItems.sort((a, b) => (a.date > b.date ? 1 : -1))
    // const sorted = concatItems.sort((a, b) => (b.date - a.date ? 1 : -1))
    return sorted
  }
  const convertUser = users.length > 0 ? isArray(users) : isObject(users)
  const filteredItems = filterArray(convertUser, 'tableName', filterValue);

  const {currentPosts, totalPages} = pagination(filteredItems,currentPage, postPerPage )
  const onChangeFilter = (e) => {
    setFilterValue(e.target.value)
  }
  const onChangepage = (e, page) => {
    setCurrentPage(page);
  }

  useEffect(() => {
    setCurrentPage(1)
  },[users,filterValue])

  return (
    <div>
      <FilterCategory
        keys={convertUser}
        filterValue={filterValue}
        onChangeFilter={onChangeFilter}
      />
      <TimeLine userInfo={currentPosts} />
      <Pagination count={totalPages} onChange={onChangepage} defaultPage={1}/>
    </div>
  )
}

export default TimeLineFilters
